import { Dispatch, SetStateAction } from 'react'

import { Skeleton } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import { toast } from 'react-toastify'

import {
  useGetVehicleQuery,
  CreateAndUpdateVehicleDtoInput,
  GetVehicleQuery,
} from 'generated/graphql'

import { VehicleForm } from './VehicleForm'

interface IProps {
  driverId: number
  vehicleId: number
  setNotFound: Dispatch<SetStateAction<boolean>>
}

function UpdateVehicle(props: IProps) {
  const { driverId, vehicleId, setNotFound } = props
  const { reset } = useFormContext<CreateAndUpdateVehicleDtoInput>()

  // Queries
  const getVehicleOnCompleted = (data: GetVehicleQuery) => {
    if (!data.vehicle) {
      setNotFound(true)
    }
    const { __typename, vehicleTypeId, assignedDrivers, vehicleSpecialServices, ...rest } =
      data.vehicle as any

    reset({
      ...rest,
      isDefault: assignedDrivers.some((driver: any) => Number(driver.id) === driverId),
      vehicleTypeId: Number(vehicleTypeId),
      specialServiceIds: vehicleSpecialServices.map((service) => service.specialServiceId),
    } as CreateAndUpdateVehicleDtoInput)
  }

  const { loading: vehicleLoading } = useGetVehicleQuery({
    fetchPolicy: 'network-only',
    variables: {
      driverId,
      vehicleId,
    },
    onCompleted: (data) => {
      getVehicleOnCompleted(data)
    },
    onError: (error) => {
      error.graphQLErrors.map((e) => toast.error(e.message))
    },
  })

  return vehicleLoading ? (
    <Skeleton>
      <VehicleForm />
    </Skeleton>
  ) : (
    <VehicleForm />
  )
}

export default UpdateVehicle
